import {EventEmitter, Injectable, Output} from "@angular/core";
import {Observable} from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/do';
import 'rxjs/add/operator/finally';
import {Http, XHRBackend, RequestOptions, Request, RequestOptionsArgs, Response, Headers} from '@angular/http';
import {AuthService} from "../../../../services/user/auth.service";
import {LocalStorageService} from "angular-2-local-storage";


@Injectable()
export class HttpService extends Http {

  @Output() loading: EventEmitter<boolean> = new EventEmitter<boolean>(true);

  public pendingRequests: number = 0;
  public showLoading: boolean = false;

  constructor(backend: XHRBackend, defaultOptions: RequestOptions, private srvAuth: AuthService, private srvLocalStorage: LocalStorageService) {
    super(backend, defaultOptions);

  }

  request(url: string | Request, options?: RequestOptionsArgs): Observable<Response> {
    return super.request(url, options);
  }

  get(url: string, options?: RequestOptionsArgs): Observable<Response> {
 
    return this.intercept(super.get(url, options), url);
  }

  post(url: string, body: string, options?: RequestOptionsArgs): Observable<Response> {
    return this.intercept(super.post(url, body, this.getRequestOptionArgs(options)), url);
  }

  put(url: string, body: string, options?: RequestOptionsArgs): Observable<Response> {
    return this.intercept(super.put(url, body, this.getRequestOptionArgs(options)), url);
  }

  patch(url: string, body: string, options?: RequestOptionsArgs): Observable<Response> {
    return this.intercept(super.patch(url, body, this.getRequestOptionArgs(options)), url);
  }

  delete(url: string, options?: RequestOptionsArgs): Observable<Response> {
    return this.intercept(super.delete(url, options), url);
  }

  getRequestOptionArgs(options?: RequestOptionsArgs): RequestOptionsArgs {
    return options;
  }

  intercept(observable: Observable<Response>, url): Observable<Response> {
    if(url != '/oauth2/token'){
      this.turnOnModal();

      this.pendingRequests += 1;
      // console.log("PENDING REQ", this.pendingRequests, url);
    }

    return observable
      .map((res) => {
        console.log('Response: ' + res);
        return res;
      }, (err) => {
        console.log('Caught error: ' + err);
        return err;
      })
      .finally(() => {
        if(url != '/oauth2/token') {
          this.pendingRequests-=1;
          // console.log("PENDING REQ", this.pendingRequests, url);
          this.turnOffModal();
        }
      });
  }

  private turnOnModal() {
    if (this.pendingRequests === 0) {
      console.log('TURN ON SPINNER LOADING');
      this.showLoading = true;
      this.loading.emit(this.showLoading);
    }
  }

  private turnOffModal() {
    if (this.pendingRequests <= 0) {
      console.log('TURN OFF SPINNER LOADING');
      this.showLoading = false;
      this.loading.emit(this.showLoading);
      console.log('SHOW LOADING', this.showLoading);
    }
  }
  public forceOffModal() {  
    console.log("FORCE MODAL");
    this.pendingRequests = 0;
    this.showLoading = false;    
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/UIKit/components/spinnerLoading/httpServ.service.ts